import * as React from 'react';

import { Button } from '@/ui/button';
import { cn } from '@/utils';

import BookIcon from '../../assets/new_course.svg';

import { NaplanDrawer } from './naplan-drawer';

export const NaplanCard = React.forwardRef<HTMLDivElement>((_, ref) => {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const handleClick = React.useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const handleCloseDrawer = React.useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  return (
    <>
      <div
        ref={ref}
        className={cn(
          'bg-white/60 rounded-[14px] p-4',
          'flex items-center gap-4',
          'transition-all duration-200',
          'hover:shadow-lg'
        )}
      >
        {/* Icon Container */}
        <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center">
          <img src={BookIcon} alt="NAPLAN course icon" className="w-12 h-12" />
        </div>

        {/* Content */}
        <div className="flex-1" id="naplan-description">
          <h3 className="text-sm font-semibold text-gray-900">
            New NAPLAN Course Added
          </h3>
          <p className="text-xs text-gray-600 mt-0.5">
            Excel in the numeracy section
          </p>
        </div>

        {/* Action Button */}
        <Button
          variant="outline"
          size="sm"
          onClick={handleClick}
          className="flex-shrink-0"
          aria-label="View NAPLAN course details"
          aria-describedby="naplan-description"
        >
          View
        </Button>
      </div>

      {/* Drawer */}
      <NaplanDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer} />
    </>
  );
});

NaplanCard.displayName = 'NaplanCard';
